import CombinedAnalytics from './CombinedAnalytics';

export default CombinedAnalytics;
